import { fetch } from '@/plugin/axios/index.js'
import formAxios from '@/plugin/axios/formAxios.js'

/**
 * @param {Object} data
 * 技术材料
 */
export function getTechnicalDocumentList(data) {
  return fetch({
    url: '/maintain/TechnicalDocument/pageList',
    method: 'POST',
    data
  })
}


/**
 * @param {Object} data
 * 删除材料
 */
export function deleteTechnicalDocument(data) {
  return fetch({
    url: '/maintain/TechnicalDocument/delete',
    method: 'POST',
    data
  })
}

/**
 * @param {Object} data
 * 保存材料
 */
export function saveTechnicalDocument(data) {
  return fetch({
    url: '/maintain/TechnicalDocument/save',
    method: 'POST',
    data
  })
}
/**
 * 上传附件
 *
 */
export function uploadFile(data) {
  return fetch({
    url: '/foreign/storage/uploadFile',
    method: 'POST',
    data
  })
}


/**
 * @param {Object} data
 * 技术材料下拉
 */
export function getTechnicalDocumentSimpleList() {
  return fetch({
    url: '/maintain/TechnicalDocument/simpleList',
    method: 'POST',
  })
}






// WEBPACK FOOTER //
// ./src/api/TechnologyDocument/index.js